module.exports = __webpack_public_path__ + "img/icon05.20598cde.svg";